module.exports = "<iframe style=\"width: 100%;\nheight: 100vh;\" src=\"https://server3.azlogica.com/terminal\"></iframe>"